export default __webpack_public_path__ + "static/media/logo-dark.df90e58b.png";